import dynamic from "next/dynamic";

const LoadingAnimation = dynamic(() => import("./LoadingAnimation"), {
  ssr: false,
});

export default LoadingAnimation;
